import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Shell from '../../components/Shell/Shell';
import UserMenu from '../../components/Shell/UserMenu';
import { ModalProvider } from '../../context/ModalContext';
import { useApp } from '../../context/AppContextBeta';

import OrganizationsList from './OrganizationsList';
import Organization from './Organization';
import { ServiceReportsSingle } from '../../admin/ServiceReports';

const SuperAdmin = () => {
	const { refreshOrganization } = useApp();

	return (
		<ModalProvider>
			<Shell
				navigation={[{ name: 'Organizations', path: '/superadmin' }]}
				UserMenu={
					<UserMenu
						navigation={[
							{
								name: 'Back to Platform',
								onClick: () => {
									refreshOrganization();
								},
							},
							{ name: 'Sign Out', path: '/logout' },
						]}
					/>
				}
			>
				<Routes>
					<Route index element={<OrganizationsList />} />
					<Route path="organization/:id/*" element={<Organization />} />
					<Route path="service-report/:id" element={<ServiceReportsSingle />} />
				</Routes>
			</Shell>
		</ModalProvider>
	);
};

export default SuperAdmin;
